"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const identity_reducer_1 = __importDefault(require("./reducers/identity.reducer"));
const application_state_reducer_1 = __importDefault(require("./reducers/application-state.reducer"));
const tokens_reducer_1 = __importDefault(require("./reducers/tokens.reducer"));
const block_tracking_reducer_1 = __importDefault(require("./reducers/block-tracking.reducer"));
const reducer_1 = __importDefault(require("./external/transactions/reducer"));
const reducer_2 = __importDefault(require("./external/multicall/reducer"));
const reducer_3 = __importDefault(require("./external/application/reducer"));
const cart_reducer_1 = __importDefault(require("./reducers/cart.reducer"));
const store = (0, toolkit_1.configureStore)({
    reducer: {
        identity: identity_reducer_1.default,
        blockTracker: block_tracking_reducer_1.default,
        applicationState: application_state_reducer_1.default,
        tokens: tokens_reducer_1.default,
        cart: cart_reducer_1.default,
        transactions: reducer_1.default,
        application: reducer_3.default,
        multicall: reducer_2.default,
    },
});
exports.default = store;
